import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import '../../App.css';
import { SelectGenericFromTable } from '../universal/Axios';


const ParameterSetTable = () => {
    const [parameterSetResultsData, setParameterSetResultsData] = useState(undefined);

    useEffect(() => {
        SelectGenericFromTable("select * from parameter_set;", setParameterSetResultsData)
    }, []);

    const dncParamResultsColumns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 340,
            renderCell: (params) => (
                <>
                    <a
                        href={'edit-parameter-set?id=' + params.row.id}
                    >
                        {params.row.id}
                    </a>
                </>
            ),
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 440,
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            width: 160
        }
    ];

    let dncParamResultsDataRows = parameterSetResultsData?.filter(data => data != null).map((dncParamResults) =>
    ({   
        id: dncParamResults.id,
        description: dncParamResults.description,
        created_date: dncParamResults.created_date
    }))


    if (parameterSetResultsData === undefined) {
        return (<p>loading...</p>)
    }
    return (
        <DataGrid
            disableSelectionOnClick
            rows={dncParamResultsDataRows}
            columns={dncParamResultsColumns}
            pagination={true}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'created_date', sort: 'desc' }],
              },
            }}
            autoHeight
      />
    )
};

export { ParameterSetTable };
